import React from "react"
import PropTypes from "prop-types"

import Hero from "./hero"
import { LayoutBase } from "./layout"
function HeroLayout({
  pageContext: {
    frontmatter: { title, description },
  },
  pageContext,
  ...props
}) {
  return (
    <LayoutBase
      headerComponent={<Hero title={title} description={description} />}
      pageContext={pageContext}
      {...props}
    />
  )
}

HeroLayout.propTypes = {
  pageContext: PropTypes.object,
}

export default HeroLayout
